import React from 'react';
import { cn } from '../../../utils/cn';
import StatusDot from '../../atoms/StatusDot';

// Based on your .status-indicator and .latency-indicator patterns
const StatusIndicator = ({
  status = 'unknown',
  text,
  icon,
  variant = 'default',
  size = 'base',
  className,
  showDot = true,
  ...props
}) => {
  // Variant styles based on your existing patterns
  const variantStyles = {
    // Based on your .status-indicator
    default: 'bg-white/10 text-white',
    
    // Light variant for dark backgrounds
    light: 'bg-gray-100 text-gray-700',
    
    // Transparent variant
    transparent: 'bg-transparent text-current',
    
    // Colored variants
    success: 'bg-secondary-50 text-secondary-700 border border-secondary-200',
    error: 'bg-error-50 text-error-700 border border-error-200',
    warning: 'bg-warning-50 text-warning-700 border border-warning-200'
  };

  const sizeStyles = {
    sm: 'px-2 py-1 text-xs gap-1.5',     // Small status indicators
    base: 'px-3 py-1.5 text-sm gap-2',   // Your standard size
    lg: 'px-4 py-2 text-base gap-2.5'    // Larger indicators
  };

  const baseStyles = 'inline-flex items-center rounded-statusIndicator font-medium';
  const currentVariantStyles = variantStyles[variant] || variantStyles.default;
  const currentSizeStyles = sizeStyles[size] || sizeStyles.base;

  return (
    <div
      className={cn(
        baseStyles,
        currentVariantStyles,
        currentSizeStyles,
        className
      )}
      {...props}
    >
      {/* Icon (if provided) */}
      {icon && <span className="flex-shrink-0">{icon}</span>}
      
      {/* Status dot */}
      {showDot && <StatusDot status={status} size={size === 'sm' ? 'sm' : 'base'} />}
      
      {/* Text */}
      {text && <span>{text}</span>}
    </div>
  );
};

export default StatusIndicator;